import { useState } from "react";
import { NavLink as NavLinkRRD, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import dashboardLogo from '../../assets/img/dashboardlogo.png';
import './Sidebar.css';
import {
  Collapse,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
} from "reactstrap";
import Logout from "components/logout/Logout";

const logo = {
  imgSrc: dashboardLogo,
  imgAlt: 'Company Logo',
};

const Sidebar = (props) => {
  const [collapseOpen, setCollapseOpen] = useState(false);
  const location = useLocation();

  const toggleCollapse = () => {
    setCollapseOpen((prevState) => !prevState);
  };

  const closeCollapse = () => {
    setCollapseOpen(false);
  };

  const createLinks = (routes) => {
    return (
      <>
        {routes.map((prop) => {
          const isActive = location.pathname === prop.layout + prop.path;
          return (
            <NavItem key={prop.path}>
              <NavLink
                to={prop.layout + prop.path}
                tag={NavLinkRRD}
                onClick={closeCollapse}
                className={isActive ? 'active' : ''}
                style={{ fontSize: '14px', fontWeight: 500 }}
              >
                <img src={prop.icon} alt="" className="dashicon" />
                {prop.name}
              </NavLink>
            </NavItem>
          );
        })}
      </>
    );
  };

  const { routes } = props;
  // (Removed unused navbarBrandProps to keep component minimal)

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar_design"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>
        {/* Box for background */}
        <div className="logo-box" >
          {/* Image on top */}
          <div className="logo-container" >
            <img
              alt={logo.imgAlt}
              className="mt-4"
              src={logo.imgSrc}
            />
          </div>
        </div>
        <Collapse navbar isOpen={collapseOpen}>
          <Nav navbar>{createLinks(routes)}</Nav>
          <Logout />
        </Collapse>
      </Container>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    innerLink: PropTypes.string,
    outterLink: PropTypes.string,
    imgSrc: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
